import url_ from "asset-data:assets/galleries/ua-2021-12-09/L1001010-bw_a6f8b16811__264.jpg";
export const url = url_;